import React from "react";
import { Box, useTheme } from "@mui/material";
import { getAssetHierarchyPalette, getPageShellSx } from "../cmms/assetHierarchyStyles";
import RecurringSchedulesPanel from "./components/RecurringSchedulesPanel";

/*
 * Maintenance planning: what a planner sets up so work orders appear by themselves.
 *
 * One page and one form, because a schedule now carries the tool itself. The tab that briefly
 * held a separate ToolServiceInterval list is gone — a planner looking for "service this tool
 * every 50 000 cycles" goes to the schedule form and finds a tool field there, which is where
 * they looked in the first place.
 *
 * The two kinds are still reset by different events, and that difference is stated in the form
 * rather than hidden by keeping them apart: an asset schedule's anchor moves when the sweep
 * raises the order, a tool schedule's when the order closes against the tool.
 */
export default function CmmsMaintenancePlanning() {
  const theme = useTheme();
  const cmmsColors = getAssetHierarchyPalette(theme.palette.mode);

  return (
    <Box sx={getPageShellSx(cmmsColors)}>
      <RecurringSchedulesPanel />
    </Box>
  );
}
